import { useTranslation } from 'react-i18next';
import { currentTenantOrNull } from '@/lib/tenants';

// Shown only on white-label (private) tenants: a small "Powered by
// Swiss Magic" attribution at the bottom of every page. Plain text for
// now; becomes a link to the public tenant once that goes live.
export function PoweredByFooter() {
  const { t } = useTranslation('common');
  const isWhiteLabel = currentTenantOrNull()?.isWhiteLabel === true;
  if (!isWhiteLabel) return null;
  return (
    <footer
      data-testid="powered-by-footer"
      className="flex justify-center py-4 text-xs text-muted-foreground"
    >
      {t('footer.powered_by')}
    </footer>
  );
}
